import { Button } from "../../../components/ui/button";

export default function ProfileIconButton({ icon: Icon, label, className = "", spinning = false, ...props }) {
  return (
    <Button variant="outline" {...props} aria-label={label} title={label}
      className={"h-8 w-8 shrink-0 rounded-lg p-0 " + className}>
      <Icon aria-hidden="true" className={spinning ? "animate-spin" : ""} />
    </Button>
  );
}
